// @ts-nocheck: converted from JS

import PasswordReset from './PasswordReset';

export default PasswordReset;
